import { Component } from '@angular/core';
import { UserService } from 'app/services/user.service';

@Component({
    selector: 'app-streaming',
    templateUrl: './streaming.component.html'
})
export class StreamingComponent {

    public message = '';

    constructor(public userService: UserService) { }

    public sync() {
        this.message = 'Synchronisation in Arbeit';
        const URL = UserService.baseUrl.concat('syncStreamingServer');
        this.userService.syncStreaming().subscribe(
            () => this.message = 'Synchronisation erfolgreich abgeschlossen.',
            (error) => this.message = 'Synchronisation fehlerhaft'
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/streaming/streaming.component.ts